import React, { useState } from "react";
import { useCombobox } from "downshift";
import classNames from "classnames";
export const Dropdown = ({ isSearchable, selectedItem, onSelectedItemChange, options, }) => {
    const [items, setItems] = useState(options);
    const { highlightedIndex, getInputProps, getItemProps, getMenuProps } = useCombobox({
        onInputValueChange({ inputValue }) {
            setItems(options.filter((option) => {
                const lowerCasedInputValue = inputValue.toLowerCase();
                return (!inputValue ||
                    option.title.toLowerCase().includes(lowerCasedInputValue));
            }));
        },
        selectedItem,
        items,
        itemToString(item) {
            return item ? item.value : "";
        },
        onSelectedItemChange,
    });
    return (React.createElement("div", { className: "autocomplete-dropdown" },
        React.createElement("div", { className: classNames({
                "d-none": !isSearchable,
            }) },
            React.createElement("input", { placeholder: "Search...", className: "form-control", ...getInputProps() })),
        React.createElement("ul", { ...getMenuProps() }, items.map((item, index) => (React.createElement("li", { key: item.id, className: classNames([
                highlightedIndex === index && "is-highlighted",
                selectedItem.id === item.id && "is-selected",
            ]), ...getItemProps({ item, index }) }, item.node))))));
};
